import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../store/app'
import { addSupportProvider } from '../../../../store/SupportProviderSlice'
import FormSupportProvider from './FormSupportProvider'
import { Form } from 'antd'

const AddSupportProvider: React.FC<any> = ({
    getList,
    totalData
}) => {
    const dispatch: AppDispatch = useDispatch()
    const [form] = Form.useForm();
    const handleAddSubmit = (data: any) => {
        dispatch(addSupportProvider(data))
            .then(() => {
                getList();
            })
            .catch((e: any) => {
                console.warn(e)
            })
    }
    return (
        <FormSupportProvider
            form={form}
            handleAddSubmit={handleAddSubmit}
            mode={'add'}
            totalData={totalData}
        />
    )
}

export default AddSupportProvider